import { connect } from 'react-redux'
import { trackAdoptionMetricsForAddLogoUploadClickedEvent} from 'src/legacy/redux/actions/adoption';
import _ from 'lodash';
import AssetIconEditor from './view';
const mapStateToProps = (state) => {
  return {
    collectioName: _.get(state, "editCollection.item.name", false),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    trackAdoptionMetricsForAddLogoUploadClickedEvent: (collectioName) =>{
      return dispatch(trackAdoptionMetricsForAddLogoUploadClickedEvent(collectioName));
    }
  }
}

const  AssetIconEditorContainer= connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetIconEditor)

export default AssetIconEditorContainer;